import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CalendarState } from '../reducers/selected.delivery.date.reducer';

export const selectCalendarState =
  createFeatureSelector<CalendarState>('calendar');

export const selectSelectedDate = createSelector(
  selectCalendarState,
  (state) => state?.selectedDate
);
